import { useLanguage } from "@/LanguageContext";
import { ChapterLabel, MaskedLine, Reveal } from "@/components/Reveal";

const Process = () => {
  const { t } = useLanguage();
  const p = t.process;

  return (
    <section id="processo" className="border-b border-noom-line bg-white" data-testid="section-process">
      <div className="mx-auto max-w-[1600px] px-6 py-24 lg:px-16 lg:py-36">
        <ChapterLabel testId="process-label">{p.label}</ChapterLabel>
        <h2 className="mt-6 font-display text-4xl font-semibold tracking-[-0.02em] text-noom-ink sm:text-5xl">
          <MaskedLine inView>{p.heading}</MaskedLine>
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-3 lg:gap-10" data-testid="list-studio-process">
          {p.items.map((step, i) => (
            <Reveal key={i} delay={i * 0.14}>
              <div data-testid={`process-step-${i + 1}`} className="group">
                <div className="flex items-center gap-5">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-noom-line font-mono text-sm text-noom-ink transition-all duration-500 group-hover:border-noom-lilac group-hover:bg-noom-lilacLight">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="h-px flex-1 bg-noom-line" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-noom-lilacDeep">
                    {step.chip}
                  </span>
                </div>
                <h3 className="mt-8 font-display text-xl font-semibold tracking-tight text-noom-ink sm:text-2xl">
                  {step.title}
                </h3>
                <p className="mt-4 max-w-sm text-sm leading-relaxed text-noom-muted sm:text-base">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
